import React from 'react'
import FixedDropdown from './FixedDropdown'
import { Okopf } from '../../..//types'
import { OrganizationInfo } from '../../../../Org/Home/types'

type Props = {
    anchorEl: HTMLElement | null
    open: boolean
    onClose: () => void
    items: Okopf[]
    theme: string
    onPick: (it: Okopf) => void
}

const OkopfDropdown: React.FC<Props> = (p) => {
    return (
        <FixedDropdown
            anchorEl={p.anchorEl}
            open={p.open}
            onClose={p.onClose}
            minWidth={400}
            maxHeight={200}
            closeOnInsidePointerDown
        >
            <div
                onPointerDown={(e) => {
                    // если клик пришел НЕ по кнопке (пустое место/фон) — закрыть
                    const target = e.target as HTMLElement
                    const clickedButton = target.closest('button')
                    if (!clickedButton) {
                        e.stopPropagation()
                        p.onClose() // <-- закроется и в родителе сработает откат
                    }
                }}
            >
                {p.items.length ? (
                    p.items.map((it) => {
                        return (
                            <button
                                key={it.guid}
                                disabled={false}
                                className={`w-full text-left px-2 py-1 text-[11px] hover:bg-[#e4e6e8] dark:hover:bg-[#373538] text-[#181818] dark:text-[#FFFFFF] cursor-pointer`}
                                onPointerDown={(e) => {
                                    e.preventDefault() // не даём фокусам/blur закрыть список
                                    e.stopPropagation() // чтобы вне-клик не сработал
                                    p.onPick(it)
                                }}
                            >
                                <div className="flex items-start gap-2">
                                    <span className="shrink-0">{it.code}</span>
                                    <span className="whitespace-pre-wrap">
                                        {it.name}
                                    </span>
                                </div>
                            </button>
                        )
                    })
                ) : (
                    <div className="px-2 py-3 text-[#6A6A6A] dark:text-[#8A8A8A] text-[12px]">
                        Ничего не найдено
                    </div>
                )}
            </div>
        </FixedDropdown>
    )
}

export default OkopfDropdown
